import { ExtraOptions, RouterModule, Routes } from "@angular/router";
import { NgModule } from "@angular/core";
import { AuthGuard } from "./guards/auth-guard.service";
import { UserResolverService } from "./root-services/user-resolver.service";

export const routes: Routes = [
  {
    path: "auth",
    loadChildren: () =>
      import("./auth/auth.module").then((mod) => mod.NgxAuthModule),
  },

  {
    path: "pages",
    canActivate: [AuthGuard],
    resolve: {
      userInfo: UserResolverService,
    },
    loadChildren: () =>
      import("./pages/pages.module").then((m) => m.PagesModule),
  },

  { path: "", redirectTo: "auth/login", pathMatch: "full" },
  { path: "**", redirectTo: "pages/not-found" },
];

const config: ExtraOptions = {
  useHash: false,
};

@NgModule({
  imports: [RouterModule.forRoot(routes, config)],
  exports: [RouterModule],
  providers: [UserResolverService],
})
export class AppRoutingModule {}
